<template>
    <div></div>
</template>

<script>
import { getWxUserInfo } from "../../../api/coupon/personalCenter";
import { getOpenId, getBuyId } from "../../../api/coupon/auth";
import { mapMutations } from 'vuex'
import base from "@/api/base";
import { redirectToWeChatAuth } from "@/utils/redirect"
import { LocationManager } from "@/utils/LocationManagerUrl"
export default {
    name: "auth",
    data() {
        return {
       
            baseUrl: base.url + "/",
            baseHttps: base.https,
            baseHttp: base.http,
        }
    },
    created() {
        console.log(base,'baseHttps');
        if (this.$route.query.code) {//微信code
            console.log(this.$route.query.code, 'this.$route.query.code');
            getOpenId(this.$route.query.code).then(res => {
                if (res.code == 200) {//&& res.msg != 'null'
                    localStorage.setItem('userOpenId', res.msg);
                    this.setUserOpenid(res.msg);
                    let beforeUrl = localStorage.getItem('beforeUrl');
                    getWxUserInfo(res.msg).then(req => {
                        if (req.code == 200 && req.hasOwnProperty('data')) {//已注册过(之前公众号迁移过来的老用户)
                          
                        // if (false) {//已注册过(之前公众号迁移过来的老用户)
                            localStorage.setItem('userId', req.data.id);
                            this.setUserPhone(req.data.phonenumber);
                            this.setBusinessIds(req.data.businessIds);
                            let url = base.url.substr(0,5)
                            //跳转
                            if (beforeUrl) {
                                LocationManager(beforeUrl)
                            } else {
                                LocationManager("/weChat/personalCenter" + beforeUrl)
                            }
                        } else if ((beforeUrl.indexOf("userNoFollowToGetCoupon") >= 0) || (beforeUrl.indexOf("unlicensed") >= 0)|| (beforeUrl.indexOf("unlicensedEntry") >= 0)) {//无牌车进出/梅园无需绑定领券页面
                            if (beforeUrl) {
                                LocationManager(beforeUrl)
                            } else {
                                LocationManager("/weChat/personalCenter" + beforeUrl)
                            }
                        } else {//未注册去注册页
                            let url = base.url.substr(0, 5)
                            if (url == "https") {
                                LocationManager( "/weChat/register")
                           
                            } else {
                                this.$router.replace({ name: 'register' });
                            }


                        }
                    });
                } else {
                    alert('获取用户授权信息失败');
                }
            })
        } else if (this.$route.query.auth_code) {//支付宝
            getBuyId(this.$route.query.auth_code).then(res => {
                if (res.code === 200) {
                    localStorage.setItem('userBuyId', res.msg);
                    // localStorage.setItem('userOpenId', res.msg);
                    this.setBuyId(res.msg);
                    let beforeUrl = localStorage.getItem('beforeUrl');
                    console.log(base.url, 'code2');
                    let url = base.url.substr(0, 5)
                    //跳转
                    if (beforeUrl) {
                        if (url == "https") {
                            LocationManager(beforeUrl)
                        } else {
                            LocationManager('/weChat/personalCenter')
                        }

                    } else {
                        LocationManager("/weChat/personalCenter")
                    }
                }
            })
        } else {
            this.$weui.alert('获取授权信息失败！', {
                title: '提示',
                buttons: [{
                    label: '取消',
                    type: 'default',
                },
                {
                    label: '尝试重新授权',
                    type: 'primary',
                    onClick: function () {
                        redirectToWeChatAuth("/weChat/auth")
                    }
                }]
            });
        }
    },
    methods: {
        ...mapMutations({
            setUserOpenid: "SET_USER_OPENID",
            setUserPhone: "SET_USER_PHONE",
            setBusinessIds: "SET_BUSINESS_IDS",
            setBuyId: "SET_BUYID",
        }),
    }
}
</script>

<style scoped></style>






 
 
